import React from "react";
import { Card, CardContent } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { styles } from "../../layout/Styles";
import { GET_LIST } from "react-admin";
import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { DataProvider } from "../../providers";
import CloudDownload from "@material-ui/icons/CloudDownload";
import PersonIcon from "@material-ui/icons/Person";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import RoomIcon from "@material-ui/icons/Room";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import ArchiveIcon from "@material-ui/icons/Archive";
import StyleIcon from "@material-ui/icons/Style";
import AssignmentIcon from "@material-ui/icons/Assignment";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Receipt from "@material-ui/icons/Receipt";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import Kpi from "./cards/kpi";

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

export class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.styles = props.styles;
    this.state = {
      ingresos: { actual: 0, anterior: 0, list: [] },
      egresos: { actual: 0, anterior: 0, list: [] },
      produccion: { actual: 0, anterior: 0, list: [] },
      stock: 0
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  componentDidUpdate(prevProps) {
    // handle refresh
    if (this.props.version !== prevProps.version) {
      this.fetchData();
    }
  }

  async fetchData() {
    const resp = await DataProvider(GET_LIST, "data-dashboard", {});
    const estado = resp.data[0];
    this.setState(estado);
  }

  generateIngresosList = () => {
    return (
      this.state.ingresos &&
      this.state.ingresos.list.map(record => (
        <ListItem key={record._id}>
          <ListItemText primary={`${record._id}`} />
          <Typography variant="subtitle1">{record.total} kgs.</Typography>
        </ListItem>
      ))
    );
  };

  generateEgresosList = () => {
    return (
      this.state.egresos &&
      this.state.egresos.list.map(record => {
        return (
          <ListItem key={record._id}>
            <ListItemText primary={`${record._id}`} />
            <Typography variant="subtitle1">{record.total} kgs.</Typography>
          </ListItem>
        );
      })
    );
  };

  generateProduccionList = () => {
    return (
      this.state.produccion &&
      this.state.produccion.list.map(record => {
        return (
          <ListItem key={record._id}>
            <ListItemText primary={`${record._id}`} />
            <Typography variant="subtitle1">{record.total} kgs.</Typography>
          </ListItem>
        );
      })
    );
  };

  renderAdminCard() {
    return (
      <Grid>
        <Grid container spacing={16}>
          <Grid item xs={12} md={3}>
            <Kpi
              titulo="Ingresos totales del último mes"
              subtitulo="Total por etapa"
              actual={this.state.ingresos.actual}
              anterior={this.state.ingresos.anterior}
              list={this.generateIngresosList()}
              icon={StyleIcon}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Kpi
              titulo={"Egresos totales del último mes"}
              subtitulo={"Total por material"}
              actual={this.state.egresos.actual}
              anterior={this.state.egresos.anterior}
              list={this.generateEgresosList()}
              icon={Receipt}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Kpi
              titulo="Producción Total del último mes"
              subtitulo="Total por material"
              actual={this.state.produccion.actual}
              anterior={this.state.produccion.anterior}
              list={this.generateProduccionList()}
              icon={AssignmentIcon}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Kpi
              titulo="Stock"
              actual={this.state.produccion.actual - this.state.egresos.actual}
              anterior={
                this.state.produccion.anterior - this.state.egresos.anterior
              }
              icon={ArchiveIcon}
            />
          </Grid>
        </Grid>
        <Grid container spacing={16}>
          <Grid item xs={12} md={6}>
            <Card style={styles.botomSpace}>
              <CardContent>
                <h3>Usuarios</h3>
                <List component="nav">
                  <ListItemLink href="#/administradores">
                    <ListItemIcon>
                      <PersonOutlineIcon />
                    </ListItemIcon>
                    <ListItemText primary="Administradores" />
                  </ListItemLink>
                  <ListItemLink href="#/recuperadores">
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Recuperadores" />
                  </ListItemLink>
                  <ListItemLink href="#/coordinadores">
                    <ListItemIcon>
                      <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary="Coordinadores" />
                  </ListItemLink>
                  <ListItemLink href="#/pesadores">
                    <ListItemIcon>
                      <ShoppingBasketIcon />
                    </ListItemIcon>
                    <ListItemText primary="Pesadores" />
                  </ListItemLink>
                  <ListItemLink href="#/enfardadores">
                    <ListItemIcon>
                      <ViewCarouselIcon />
                    </ListItemIcon>
                    <ListItemText primary="Enfardadores" />
                  </ListItemLink>
                  <ListItemLink href="#/auditores">
                    <ListItemIcon>
                      <VerifiedUserIcon />
                    </ListItemIcon>
                    <ListItemText primary="Auditores" />
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
            <Card>
              <CardContent>
                <h3>Gestión</h3>
                <List component="nav">
                  <ListItemLink
                    href={`${process.env.REACT_APP_API_URL}/recuperadores.csv`}
                  >
                    <ListItemIcon>
                      <CloudDownload />
                    </ListItemIcon>
                    <ListItemText primary="exportar recuperadores" />
                  </ListItemLink>
                  <ListItemLink href="#/exportar-pesaje">
                    <ListItemIcon>
                      <CloudDownload />
                    </ListItemIcon>
                    <ListItemText primary="Exportar pesajes por fecha" />
                  </ListItemLink>
                </List>
                <Divider />
                <List component="nav">
                  <ListItemLink href="#/materiales">
                    <ListItemIcon>
                      <StyleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Listado de materiales" />
                  </ListItemLink>
                  <ListItemLink href="#/entidades">
                    <ListItemIcon>
                      <StoreMallDirectoryIcon />
                    </ListItemIcon>
                    <ListItemText primary="Entidades" />
                  </ListItemLink>
                </List>
                <ListItemLink href="#/grandes-generadores">
                  <ListItemIcon>
                    <LocationCityIcon />
                  </ListItemIcon>
                  <ListItemText primary="Grandes generadores" />
                </ListItemLink>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <h3>Operaciones</h3>
                <List component="nav">
                  <ListItemLink href="#/etapas">
                    <ListItemIcon>
                      <PersonPinCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Etapas" />
                  </ListItemLink>
                  <ListItemLink href="#/etapas-grandes-generadores">
                    <ListItemIcon>
                      <RoomIcon />
                    </ListItemIcon>
                    <ListItemText primary="Etapas de Grandes generadores" />
                  </ListItemLink>
                </List>
                <Divider />
                <h4>Ingreso de materiales</h4>
                <List component="nav">
                  <ListItemLink href="#/pesajes">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Puerta a puerta" />
                  </ListItemLink>
                  <ListItemLink href="#/ingreso-terceros">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Terceros" />
                  </ListItemLink>
                  <ListItemLink href="#/ingreso-grandes-generadores">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Grandes generadores" />
                  </ListItemLink>
                </List>
                <Divider />
                <h4>Producción</h4>
                <List component="nav">
                  <ListItemLink href="#/pesaje-material">
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Pesaje de materiales" />
                  </ListItemLink>
                </List>
                <Divider />
                <h4>Salida de materiales</h4>
                <List component="nav">
                  <ListItemLink href="#/remitos">
                    <ListItemIcon>
                      <Receipt />
                    </ListItemIcon>
                    <ListItemText primary="Salidas" />
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { user } = this.props;
    return this.renderAdminCard(user);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/Admin.js